import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { getNameMeta } from '../lib/nameMeta';

// Renders a deal code name and, on hover, shows its topic (header) + definition (italic).
export function CodeNameTag({ name, className = '', prefix = '', testId, block = false }) {
  if (!name) return null;
  const El = block ? 'div' : 'span';
  const tag = <El className={className} data-testid={testId}>{prefix}{name}</El>;
  const meta = getNameMeta(name);
  if (!meta.topic && !meta.definition) return tag;
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{tag}</TooltipTrigger>
        <TooltipContent className="max-w-[260px]" data-testid="code-name-tooltip">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-blue-400">{meta.topic}</p>
          <p className="text-xs italic text-muted-foreground mt-0.5 leading-snug">{meta.definition}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
